import {Action, di} from "@dp-instant/core";
import {TypesFlow} from "@dp-instant/interfaces";
import {SocialFlowAction} from "@dp-instant/gameflow";
import {UIEvents} from "@dp-instant/ui";
import {GameModel} from "@game/coregame/model/GameModel";
import {TypesGame} from "@game/TypesGame";
import {PopupType} from "@game/ui/PopupType";
import {inject, injectable} from "inversify";
import {ShowWinPopupAction} from "./ShowWinPopupAction";
import {Playdeck} from "@game/coregame/utils/Playdeck";

@injectable()
export class StageEndAction extends SocialFlowAction<boolean> {
    @inject(TypesGame.model)
    private readonly model: GameModel;

    @inject(TypesFlow.LevelNext)
    private readonly levelNext: Action;

    async launch(win = false) {
        const {meta, cookie, social, currentContinent} = this.model;
        cookie.absoluteTryNum++;
        this.social.me.scoreSession = Math.round(currentContinent.getTotalScore());
        await di.get<Action>(TypesGame.actions.tournamentPostScore)?.run();
        di.get<Action<boolean>>(TypesGame.actions.updateBotLevelAction)?.run(win);

        if (win) {
            Playdeck.sendProgress(cookie.absoluteTryNum);
        }

        if (social.inSolo) {
            if (win) {
                await this.winSolo();
            } else {
                this.dispatch(UIEvents.POPUP, {
                    id: PopupType.LOSE,
                    props: {coins: meta.getReward() * meta.loseMultiplier}
                });
            }
        } else {
            await di.get<Action<boolean>>(TypesGame.actions.battleResultsPopup)?.run(win);
            await this.levelNext.run();
        }
    }
    protected async winSolo() {
        await di
            .get<ShowWinPopupAction>(TypesGame.actions.winPopup)
            ?.run({id: PopupType.WIN_STAGE, props: {showRewardAd: this.model.offerX3()}});
        await di.get<Action>(TypesGame.actions.giftPopup)?.run();

        await this.levelNext.run();
    }

    protected needToShowAD(): boolean {
        return false;
    }
}
